// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@/modules/common/components/TextField';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';

const initialValues = {
    offerName: '',
    offerId: '',
};

const initialErrors = {
    offerName: '',
    offerId: '',
};

let abortController;

const DialogAdd = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const handleFocus = (prop) => () => {
        setErrors({...errors, [prop]: ''});
    };

    const handleSubmit = (event) => {
        abortController = new AbortController();

        event.preventDefault();
        setFetching(true);
        props.fetch.post('/api/offers/', {offer_name: values.offerName, offer_id: values.offerId}, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.offerName = (data.offer_name) ? data.offer_name[0] : '';
                    _errors.offerId = (data.offer_id) ? data.offer_id[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
    };

    return (
        <DialogForm title="Добавление оффера" label="Добавить"
                    open={props.open} onClose={handleClose} onSubmit={handleSubmit}
                    disabled={fetching}

        >
            <>
                <TextField label="Название"
                           value={values.offerName} onChange={handleChange('offerName')}
                           error={errors.offerName.length > 0}
                           helperText={errors.offerName}
                           onFocus={handleFocus('offerName')}
                           autoFocus={true}
                />
                <TextField label="ID" type="number" inputProps={{min: 1}}
                           value={values.offerId} onChange={handleChange('offerId')}
                           error={errors.offerId.length > 0}
                           helperText={errors.offerId}
                           onFocus={handleFocus('offerId')}
                />
            </>
        </DialogForm>
    );
};

DialogAdd.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogAdd;
Component = withFetch(Component);

export default Component;
